var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHearing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6042_89)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6042_89",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 49,
    height: 49
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.000255585H48.3469V48.3467H0V-0.000255585Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6042_89)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6221 15.0708C19.6221 7.53481 25.7407 1.41656 33.2763 1.41656C40.8119 1.41656 46.9305 7.53481 46.9305 15.0708C46.9305 27.2079 37.8277 28.7251 37.8277 37.8278C37.8277 42.8519 33.7489 46.9307 28.7249 46.9307C23.7009 46.9307 19.6221 42.8519 19.6221 37.8278",
    stroke: "#2CA6A4",
    strokeWidth: 2.83283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4105 12.4884C34.7978 12.4884 30.2418 17.0446 30.2418 22.6568C30.2418 20.1447 28.202 18.1053 25.6904 18.1053V15.071C25.6904 10.8844 29.0895 7.48536 33.2761 7.48536C37.4626 7.48536 40.8618 10.8844 40.8618 15.071C40.8618 20.5806 38.1248 23.0878 36.1412 25.7876C33.6622 29.1613 31.759 32.6641 31.759 37.8281C31.759 39.5026 30.3996 40.8623 28.7248 40.8623C27.0498 40.8623 25.6904 39.5026 25.6904 37.8281",
    stroke: "#2CA6A4",
    strokeWidth: 2.83283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2078 27.2078H22.6564L21.1392 22.6564L18.105 31.7591L13.5536 18.105L9.00216 36.3105L5.96791 27.2078H1.4165",
    stroke: "#2CA6A4",
    strokeWidth: 2.83283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6042_89"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.3469,
    height: 48.3469,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHearing);
export default __webpack_public_path__ + "static/media/hearing.3d67f18cbfadbda8ea17548116eb2fc2.svg";
export { ForwardRef as ReactComponent };